import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { aliasText } from "../../../../utils";

enum FormField {
    alias,
    nameKy,
    nameRu
}

interface IProps {
    show: boolean;
    realEstateLangCategory: EntDirectoryInfoName;
    onHide: () => void;
    onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>;
}

export const AddRealEstateLangCategoryModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.alias, value: props.realEstateLangCategory.alias },
            { name: FormField.nameKy, value: props.realEstateLangCategory.nameKy },
            { name: FormField.nameRu, value: props.realEstateLangCategory.nameRu },
        ]);
    }

    const setEntityFromFields = (): EntDirectoryInfoName => {
        let res = _.cloneDeep(props.realEstateLangCategory);
        res.alias = form.getFieldValue(FormField.alias);
        res.nameKy = form.getFieldValue(FormField.nameKy);
        res.nameRu = form.getFieldValue(FormField.nameRu);
        return res;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={ props.realEstateLangCategory.id === 0 ? t('handbooks.real_estate_categories.add_real_estate_categories') : t('handbooks.real_estate_categories.edit_real_estate_categories') }
                visible={ props.show }
                onCancel={ props.onHide }
                onSubmit={ handleSubmit }
                submitLoading={ loading }
            >
                <Form
                    initialValues={ { remember: true } }
                    autoComplete="off"
                    layout="vertical"
                    form={ form }
                >
                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={ t('general.nameKy') }
                        name={ FormField.nameKy }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameRu') }
                        name={ FormField.nameRu }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>
    )
}
